import { ScenarioData, SendApiRequest } from '@inbox-demo-nx/types';

function getScenarioDataFromCustomChannelType(
  scenario: ScenarioData,
  customChannelType: string
) {
  return scenario.channels.find((c) => c.customType === customChannelType);
}

export async function getScenarioDataFromChannelUrl(
  scenario: ScenarioData,
  channelUrl: string,
  sendApiRequest: SendApiRequest
) {
  const channel = await sendApiRequest({
    type: 'getGroupChannel',
    data: { channelUrl },
  });
  return getScenarioDataFromCustomChannelType(scenario, channel.custom_type);
}
